// Predefined color palette with distinct, readable colors
// All colors are light enough for dark text readability
export const ADVERTISER_COLOR_PALETTE: string[] = [
    '#FFE5E5', // Light red
    '#FFE5F0', // Light pink
    '#FFE5FA', // Light magenta
    '#F0E5FF', // Light purple
    '#E5E5FF', // Light blue
    '#E5F0FF', // Light sky blue
    '#E5FAFF', // Light cyan
    '#E5FFF0', // Light mint
    '#E5FFE5', // Light green
    '#F0FFE5', // Light lime
    '#FAFFE5', // Light yellow
    '#FFF5E5', // Light peach
    '#FFF0E5', // Light orange
    '#FFEBE5', // Light coral
    '#FFE5EB', // Light rose
    '#F5E5FF', // Light lavender
    '#E5F5FF', // Light powder blue
    '#E5FFFA', // Light aqua
    '#F0FFFA', // Light seafoam
    '#FAFFFA', // Light cream
    '#FFF5F0', // Light apricot
    '#F0F5FF', // Light periwinkle
    '#F5F0FF', // Light lilac
    '#FFFAE5', // Light butter
    '#E5FAE5', // Light sage
    '#FAE5FF', // Light orchid
    '#E5EBFF', // Light cornflower
    '#EBE5FF', // Light violet
    '#FFEBF0', // Light blush
    '#F0EBFF', // Light wisteria
];

// Generate a consistent color based on advertiser_id using predefined palette
export const getColorForAdvertiser = (advertiserId: string): string => {
    if (!advertiserId) return '#f0f0f0';

    // Hash function to convert string to number
    let hash = 0;
    for (let i = 0; i < advertiserId.length; i++) {
        hash = advertiserId.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Map hash to palette index
    const colorIndex = Math.abs(hash) % ADVERTISER_COLOR_PALETTE.length;
    return ADVERTISER_COLOR_PALETTE[colorIndex];
};

// Determine appropriate text color based on background color brightness
export const getTextColorForBackground = (backgroundColor: string): string => {
    if (!backgroundColor) return '#333333';

    // Handle HSL color format: hsl(hue, saturation%, lightness%)
    const hslMatch = backgroundColor.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
    if (hslMatch) {
        const lightness = parseInt(hslMatch[3], 10);
        return lightness < 60 ? '#ffffff' : '#333333';
    }

    // Handle hex colors
    if (backgroundColor.startsWith('#')) {
        const hex = backgroundColor.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        // Calculate relative luminance (perceived brightness)
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance < 0.5 ? '#ffffff' : '#333333';
    }

    // Default to dark text
    return '#333333';
};
